import Page from "@insite/mobius/Page";

Page.defaultProps = {
    background: "common.background",
    padding: 0,
    fullWidth: [true, true, true, true, true],
};
